
<div class="container-fluid hero mx-0-auto  backgroundHeroEmpresarial   py-3">
  <div class="row flex-lg-row-reverse align-items-center  ">
    <div class=" col-sm-8 col-lg-6">
      <img src="{{ routeImage }}" class="d-block mx-lg-auto img-fluid imgHero"   loading="lazy" alt="MoviLink">
    </div>
    <div class="col-lg-6  ">

      <div class="my-4 mx-5">
        <div class="container px-0 py-2">
          <img src="{{ routeLogo }}" style="width: 3rem" class=" "   >

        </div>
        <span class=" fs-1 lh-1 fw-bolder text-light">{{ name }}</span>
      </div>
      <div class="texts mx-5">
        <h3 class=" lh-1 fs-4 text-light">{{ description }}</h3>
        <h3 class=" lh-1 fs-4 text-light">{{ description2 }}</h3>
      </div>

    </div>
  </div>
</div>


